import { parseRelaxed } from './relaxedParser';

export function findJsonSegments(text) {
  const segments = [];
  let i = 0;
  let textStart = 0;

  while (i < text.length) {
    const ch = text[i];
    if (ch === '{' || ch === '[') {
      const open = ch;
      const close = ch === '{' ? '}' : ']';
      let depth = 0;
      let j = i;
      let inString = false;
      let stringChar = null;
      let escaped = false;
      let matched = false;

      for (; j < text.length; j++) {
        const c = text[j];
        if (inString) {
          if (escaped) {
            escaped = false;
          } else if (c === '\\') {
            escaped = true;
          } else if (c === stringChar) {
            inString = false;
          }
          continue;
        }
        if (c === '"' || c === "'") {
          inString = true;
          stringChar = c;
          continue;
        }
        if (c === open) depth++;
        else if (c === close) {
          depth--;
          if (depth === 0) {
            matched = true;
            break;
          }
        }
      }

      if (matched) {
        const candidate = text.slice(i, j + 1);
        let parsed = null;
        let relaxed = false;

        try {
          parsed = JSON.parse(candidate);
        } catch (e) {
          const relaxedResult = parseRelaxed(candidate);
          if (relaxedResult !== null) {
            parsed = relaxedResult;
            relaxed = true;
          }
        }

        if (parsed && typeof parsed === 'object') {
          if (i > textStart) segments.push({ type: 'text', value: text.slice(textStart, i) });
          segments.push({ type: 'json', value: candidate, parsed, relaxed });
          i = j + 1;
          textStart = i;
          continue;
        }
      }
    }
    i++;
  }

  if (textStart < text.length) segments.push({ type: 'text', value: text.slice(textStart) });
  return segments;
}

const PATH_REGEX = /(?:\/[\w.-]+)+\.\w+(?::\d+)?|\b[\w.-]+\.(?:cpp|c|h|js|jsx|ts|tsx|py|json|log|txt|java|go|rb)(?::\d+)?\b/g;

export function splitPaths(text) {
  const segments = [];
  let lastIndex = 0;
  let match;
  PATH_REGEX.lastIndex = 0;
  while ((match = PATH_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) segments.push({ type: 'text', value: text.slice(lastIndex, match.index) });
    segments.push({ type: 'path', value: match[0] });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) segments.push({ type: 'text', value: text.slice(lastIndex) });
  return segments;
}

export function parseMessageSegments(text) {
  const jsonPass = findJsonSegments(text);
  const final = [];
  jsonPass.forEach((seg) => {
    if (seg.type === 'text') final.push(...splitPaths(seg.value));
    else final.push(seg);
  });
  return final;
}